module.exports = __webpack_public_path__ + "static/media/Montserrat-Black.27e3649b.ttf";